var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.694 17.127 4.29-3.183 1.942 1.942c.651.651 1.706.651 2.357 0l.59-.589c.65-.65.65-1.706 0-2.357l-.295-.295.691-1.152c.127-.211.3-.392.505-.529l1.81-1.206.235.236c.65.65 1.706.65 2.357 0l.59-.59c.65-.65.65-1.706 0-2.357l-5.893-5.892a1.667 1.667 0 0 0-2.357 0l-.59.59c-.65.65-.65 1.705 0 2.356l.354.354-.971 1.803c-.173.321-.446.576-.778.727l-1.109.504-.442-.442a1.667 1.667 0 0 0-2.357 0l-.59.59c-.65.65-.65 1.706 0 2.357l1.943 1.942-3.183 4.29a.644.644 0 0 0 .901.9Zm12.102-9.514-2.947 1.965c-.41.273-.755.635-1.01 1.058l-1.36 2.268 1.215 1.214-.59.59-5.892-5.893.59-.59 1.258 1.26 2.16-.982a3.333 3.333 0 0 0 1.556-1.455l1.56-2.895-1.231-1.23.59-.59 5.892 5.893-.59.59-1.201-1.203Z",
    fill: "#fff"
  })));
};

export default SvgPin;